<template>
  <div
    v-if="item?.children?.length"
    class="block w-full justify-center border-t border-gray-200 bg-white px-5 py-6 drop-shadow-md"
    data-testid="desktop-navigation-flyout"
  >
    <nav
      class="container grow grid-cols-subgrid justify-between gap-x-14 lg:col-span-12"
    >
      <div class="flex gap-x-14">
        <template v-for="(group, groupIdx) in groupedColumns" :key="groupIdx">
          <ul class="flex break-before-column flex-col">
            <li v-for="columnItem in group" :key="columnItem.id">
              <SFNavigationTreeItem
                :navigation-item="columnItem"
                :class="
                  columnItem.children.length > 0
                    ? '!mb-3 text-xl !font-medium text-gray-600'
                    : '!my-1'
                "
                @click="onItemClick(columnItem)"
              />

              <ul
                v-if="columnItem.children.length > 0"
                class="mb-3 w-fit flex-col flex-wrap"
              >
                <li v-for="rowItem in columnItem.children" :key="rowItem.id">
                  <SFNavigationTreeItem
                    :navigation-item="rowItem"
                    class="my-3 text-gray-500"
                    @click="onItemClick(rowItem)"
                  />
                </li>
              </ul>
            </li>
          </ul>
        </template>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { NavigationTreeItem as NavigationTreeItemType } from '@scayle/storefront-nuxt'
import SFNavigationTreeItem from '~/components/SFNavigationTreeItem.vue'

const props = defineProps<{ item: NavigationTreeItemType }>()
const item = props.item

const emit = defineEmits<{ close: [] }>()

const onItemClick = (item: NavigationTreeItemType) => {
  if (item?.customData?.disabledLink) {
    return
  }
  emit('close')
}

// Group logic: every 10 items without children, break into a new column; items with children are their own column
const groupedColumns = computed(() => {
  if (!item?.children) {
    return []
  }

  const columns: NavigationTreeItemType[][] = []
  let currentGroup: NavigationTreeItemType[] = []
  let count = 0

  for (const child of item.children) {
    const itemsToAdd = 1 + (child.children?.length || 0)
    if (count + itemsToAdd > 13 && currentGroup.length) {
      columns.push(currentGroup)
      currentGroup = []
      count = 0
    }
    currentGroup.push(child)
    count += itemsToAdd
  }
  if (currentGroup.length) {
    columns.push(currentGroup)
  }
  return columns
})
</script>
